import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
import { useRoute, RouteProp } from '@react-navigation/core'
import { useNavigation } from '@react-navigation/native'
import React, { useEffect, useState } from 'react'
import { AepsButton } from '../../comps/AepsButton'
import { Container } from '../../comps/Container'
import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
import { Screens } from '../../nav/Screens'
import { BbpsStackParamList } from '../../nav/Bbps'
import { Image, ImageSourcePropType, TouchableOpacity } from 'react-native'

export const TransactionDetails = () => {
  const route = useRoute<any>()
  const navigation = useNavigation<any>()
  const { orderId, billDetails } = route.params || {}
  const [showDetailsDrawer, setShowDetailsDrawer] = useState(false)

  const formatDate = (dateStr: string) => {
    if (!dateStr) return 'N/A'
    const date = new Date(dateStr)
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
  }

  const product = billDetails?.order?.product
  const payment = billDetails?.order?.payment
  const paymentId = billDetails?.order?.payment?.id
  const paymentAt = billDetails?.order?.payment?.paymentAt
  const formattedPaymentDate = formatDate(paymentAt)
  const BBPSAssuredLogo: ImageSourcePropType = require('../../assets/images/BAssuredpng.png')
  const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
  const amount = payment?.amountDetails?.netAmount || '0.00'

  useEffect(() => {
    localStorage.removeItem('pending_order_value')
    sessionStorage.removeItem('pending_order_value')
  }, [])

  const onDonePress = () => {
    navigation.reset({
      index: 0,
      routes: [{ name: Screens.BBPS_HOME_SCREEN as any }],
    })
  }

  const handleViewDetails = () => {
    navigation.navigate(Screens.VIEW_DETAILS, { billDetails })
  }

  return (
    <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
      <Box flex={1}>
        <Box width={'100%'} height={'100%'} justifyContent={'space-between'}>
          <Box overflow={'auto'}>
            {/* Success Header Section */}
            <Box mb={24}>
              <Box backgroundColor="WHITE" borderRadius={50}>
                <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={48} />
              </Box>
              <SpacerNew size={14} />
              <Box gap={4}>
                <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'} >
                  {'Bill Payment Successful'}
                </TextNew>
              </Box>
            </Box>

            <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

            <Box width={'100%'} mb={15}>
              <Box flexDirection={'row'} justifyContent={'space-between'} mb={4}>
                <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1" fontWeight="500">
                  {product?.name || 'BBPS Biller'}
                </TextNew>
                <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1">
                  {'Amount'}
                </TextNew>
              </Box>
              <Box flexDirection={'row'} justifyContent={'space-between'} alignItems="center">
                <TextNew fontSize={20} color="BLACK" fontWeight="500">
                  {product?.attribute?.authenticatorList?.[0] || 'N/A'}
                </TextNew>
                <TextNew fontSize={18} color="BLACK" fontWeight={'bold'}>
                  ₹ {amount}
                </TextNew>
              </Box>
            </Box>

            <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

            <Box
              flexDirection={'row'}
              alignItems="center"
              backgroundColor="ALTO_DISABLED"
              padding={12}
              borderRadius={8}
              mb={15}>
              {/* <Icon id={'TIMER'} color="BRAND_COLOR_GRAY_1" size={16} /> */}

              <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1" flex={1}>
                {"Payment will reflect at biller's end after 2-3 working days"}
              </TextNew>
              <SpacerNew direction="horizontal" size={10} />
              <Image source={BBPSAssuredLogo} style={{ width: 60, height: 60, resizeMode: 'contain' }} />
            </Box>

            <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

            {/* View Details Action */}
            <TouchableOpacity onPress={handleViewDetails} style={{ paddingVertical: 10 }}>
              <Box flexDirection="row" alignItems="center" justifyContent="space-between">
                <TextNew fontSize={16} color="BRAND_PRIMARY_ACTION" fontWeight="500">
                  {'View Details'}
                </TextNew>
                <Icon id="ARROW_RIGHT" color="BRAND_PRIMARY_ACTION" size={14} />
              </Box>
            </TouchableOpacity>

            <Box mt={20} backgroundColor="WHITE" padding={20} borderRadius={16} customShadowStyle="shadowPrimary">
              <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1" fontWeight="bold">
                {'Amount Paid by Customer'}
              </TextNew>
              <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

              <Box flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
                <Box>
                  <TextNew fontSize={22} fontWeight={'BOLD'} color="BLACK">
                    ₹ {amount}
                  </TextNew>
                  <TextNew fontSize={11} color="BRAND_COLOR_GRAY_2">
                    {'*Inclusive of all taxes & fees'}
                  </TextNew>
                </Box>
                <TouchableOpacity onPress={() => setShowDetailsDrawer(true)}>
                  <Box flexDirection="row" alignItems="center">
                    <TextNew fontSize={14} color="BRAND_PRIMARY_ACTION" fontWeight="500">
                      {'View Breakup'}
                    </TextNew>
                    <SpacerNew direction="horizontal" size={4} />
                    <Icon id="ARROW_DOWN" color="BRAND_PRIMARY_ACTION" size={12} />
                  </Box>
                </TouchableOpacity>
              </Box>
            </Box>
          </Box>

          {/* Footer Section */}

          <Box width={'100%'} mt={20}>
            <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
            <Box flexDirection="row" align="center" justify="center" mt={15}>
              <TextNew fontSize={11} color="BRAND_COLOR_GRAY_1">
                Powered by
              </TextNew>
              <SpacerNew direction="horizontal" size={8} />
              <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
            </Box>
          </Box>
        </Box>
      </Box>

      <VerticleDrawerDialog
        show={showDetailsDrawer}
        type="POSITIVE"
        message="VerticleDrawerDialog message"
        onPress={() => setShowDetailsDrawer(false)}>
        <Box width={'100%'} padding={5}>
          <Box alignItems="center" mb={20}>
            <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={30} />
            <SpacerNew size={8} />
            <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
              ₹ {amount}
            </TextNew>
            <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
              {product?.name}
            </TextNew>
          </Box>

          <Box backgroundColor="ALTO_DISABLED" padding={15} borderRadius={12} gap={12}>
            <DrawerRow label="Biller" value={product?.name} />
            <DrawerRow label="Agent Commission" value="₹ 0.00" />
            <DrawerRow label="Net Amount" value={`₹ ${amount}`} isBold />
            <Box height={1} backgroundColor="WHITE" marginVertical={4} />
            <DrawerRow label="Transaction ID" value={orderId} />
            <DrawerRow label="BBPS Ref No." value={paymentId} />
            <DrawerRow label="Payment Time" value={formattedPaymentDate} />
          </Box>

          <Box width={'100%'} mt={20}>
            <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
            <Box flexDirection="row" align="center" justify="center" mt={15}>
              <TextNew fontSize={11} color="BRAND_COLOR_GRAY_1">
                Powered by
              </TextNew>
              <SpacerNew direction="horizontal" size={8} />
              <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
            </Box>
          </Box>
        </Box>
      </VerticleDrawerDialog>
    </Container>
  )
}

const DetailRow = ({ label, value }: { label: string; value: string | number }) => (
  <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'flex-start'}>
    <TextNew fontSize={13} color="BRAND_COLOR_GRAY_2" fontWeight={'500'} flex={1}>
      {label}
    </TextNew>
    <TextNew fontSize={13} color="BRAND_PURE_BLACK" fontWeight={'500'} flex={1.5} textAlign="right">
      {value}
    </TextNew>
  </Box>
)

const DrawerRow = ({ label, value, isBold = false }: any) => (
  <Box flexDirection="row" justifyContent="space-between" alignItems="center">
    <TextNew fontSize={13} color="BRAND_COLOR_GRAY_2">
      {label}
    </TextNew>
    <TextNew fontSize={13} fontWeight={isBold ? 'bold' : '500'} color="BLACK" textAlign="right" flex={1}>
      {value || 'N/A'}
    </TextNew>
  </Box>
)

// import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
// import { useRoute, RouteProp } from '@react-navigation/core'
// import { useNavigation } from '@react-navigation/native'
// import React, { useEffect, useState } from 'react'
// import { AepsButton } from '../../comps/AepsButton'
// import { Container } from '../../comps/Container'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { Screens } from '../../nav/Screens'
// import { BbpsStackParamList } from '../../nav/Bbps'
// import { Image, ImageSourcePropType, TouchableOpacity } from 'react-native'

// export const TransactionDetails = () => {
//   const route = useRoute<any>()
//   const navigation = useNavigation<any>()
//   const { orderId, billDetails } = route.params || {}
//   const [showDetailsDrawer, setShowDetailsDrawer] = useState(false)

//   const formatDate = (dateStr: string) => {
//     if (!dateStr) return 'N/A'
//     const date = new Date(dateStr)
//     return date.toLocaleString('en-IN', {
//       day: '2-digit', month: 'short', year: 'numeric',
//       hour: '2-digit', minute: '2-digit', hour12: true,
//     })
//   }

//   const product = billDetails?.order?.product
//   const payment = billDetails?.order?.payment
//   const paymentId = billDetails?.order?.payment?.id
//   const paymentAt = billDetails?.order?.payment?.paymentAt
//   const formattedPaymentDate = formatDate(paymentAt)
//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
//   const amount = payment?.amountDetails?.netAmount || '0.00'

//   useEffect(() => {
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onDonePress = () => {
//     navigation.reset({
//       index: 0,
//       routes: [{ name: Screens.BBPS_HOME_SCREEN as any }],
//     })
//   }

//   const handleViewDetails = () => {
//     navigation.navigate(Screens.VIEW_DETAILS, { billDetails })
//   }

//   return (
//     <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
//       <Box flex={1} padding={20} justifyContent="space-between">
//         <Box width={'100%'} height={'100%'} justifyContent={'space-between'}>
//           {/* Header Status */}
//           <Box overflow={'auto'}
//           // alignItems="center" mt={10}
//           mb={20}>
//             <Box backgroundColor="ALTO_DISABLED" borderRadius={50} padding={12} mb={10}>
//               <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={40} />
//             </Box>
//             <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'} textAlign="center">
//               {'Bill Payment Successful'}
//             </TextNew>
//           </Box>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//           {/* Quick Summary Row */}
//           <Box width={'100%'} mb={15}>
//             <Box flexDirection={'row'} justifyContent={'space-between'} mb={4}>
//               <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1" fontWeight="500">
//                 {product?.name || 'BBPS Biller'}
//               </TextNew>
//               <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1">
//                 {'Amount'}
//               </TextNew>
//             </Box>
//             <Box flexDirection={'row'} justifyContent={'space-between'} alignItems="center">
//               <TextNew fontSize={20} color="BLACK" fontWeight="500">
//                 {product?.attribute?.authenticatorList?.[0] || 'N/A'}
//               </TextNew>
//               <TextNew fontSize={18} color="BLACK" fontWeight={'bold'}>
//                 ₹ {amount}
//               </TextNew>
//             </Box>
//           </Box>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//           {/* Time Warning/Info */}
//           <Box flexDirection={'row'} alignItems="center" backgroundColor="ALTO_DISABLED" padding={12} borderRadius={8} mb={15}>
//              <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1" flex={1}>
//               {"Payment will reflect at biller's end after 2-3 working days"}
//             </TextNew>
//             <SpacerNew direction="horizontal" size={10} />
//             <Icon id={'TIMER'} color="BRAND_COLOR_GRAY_1" size={16} />
//           </Box>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//           {/* View Details Action */}
//           <TouchableOpacity onPress={handleViewDetails} style={{ paddingVertical: 10 }}>
//             <Box flexDirection="row" alignItems="center" justifyContent="space-between">
//               <TextNew fontSize={16} color="BRAND_PRIMARY_ACTION" fontWeight="500">
//                 {'View Details'}
//               </TextNew>
//               <Icon id="ARROW_RIGHT" color="BRAND_PRIMARY_ACTION" size={14} />
//             </Box>
//           </TouchableOpacity>

//           {/* Amount Card Section */}
//           <Box mt={20} backgroundColor="WHITE" padding={20} borderRadius={16} customShadowStyle="shadowPrimary">
//             <Icon id={'TIMER'} color="BRAND_COLOR_GRAY_1" size={16} />
//             <SpacerNew direction="horizontal" size={10} />
//             <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1" fontWeight="bold" >
//               {'Amount Paid by Customer'}
//             </TextNew>
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//             <Box flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
//               <Box>
//                 <TextNew fontSize={22} fontWeight={'BOLD'} color="BLACK">
//                   ₹ {amount}
//                 </TextNew>
//                 <TextNew fontSize={11} color="BRAND_COLOR_GRAY_2">
//                   {'*Inc Agent fee'}
//                 </TextNew>
//               </Box>
//               <TouchableOpacity onPress={() => setShowDetailsDrawer(true)}>
//                 <Box flexDirection="row" alignItems="center">
//                   <TextNew fontSize={14} color="BRAND_PRIMARY_ACTION" fontWeight="500">
//                     {'View Breakup'}
//                   </TextNew>
//                 </Box>
//               </TouchableOpacity>
//             </Box>
//           </Box>
//         </Box>

//         {/* Footer Actions */}
//         <Box width={'100%'} mt={20}>
//           <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
//           <Box flexDirection="row" align="center" justify="center" mt={15}>
//             <TextNew fontSize={11} color="BRAND_COLOR_GRAY_1">Powered by</TextNew>
//             <SpacerNew direction="horizontal" size={8} />
//             <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
//           </Box>
//         </Box>
//       </Box>

//       {/* Breakup Drawer */}
//       <VerticleDrawerDialog
//         show={showDetailsDrawer}
//         type="POSITIVE"
//         message="VerticleDrawerDialog message"
//         onPress={() => setShowDetailsDrawer(false)}
//       >
//         <Box width={'100%'} padding={5}>
//           <Box alignItems="center" mb={20}>
//             <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={30} />
//             <SpacerNew size={8} />
//             <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>₹ {amount}</TextNew>
//             <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">{product?.name}</TextNew>
//           </Box>

//           <Box backgroundColor="ALTO_DISABLED" padding={15} borderRadius={12} gap={12}>
//             <DrawerRow label="Biller" value={product?.name} />
//             <DrawerRow label="Agent Commission" value="₹ 0.00" />
//             <DrawerRow label="Net Amount" value={`₹ ${amount}`} isBold />
//             <Box height={1} backgroundColor="WHITE" marginVertical={4} />
//             <DrawerRow label="Transaction ID" value={orderId} />
//             <DrawerRow label="BBPS Ref No." value={paymentId} />
//             <DrawerRow label="Payment Time" value={formattedPaymentDate} />
//           </Box>
//         </Box>
//       </VerticleDrawerDialog>
//     </Container>
//   )
// }

// const DrawerRow = ({ label, value, isBold = false }: any) => (
//   <Box flexDirection="row" justifyContent="space-between" alignItems="center">
//     <TextNew fontSize={13} color="BRAND_COLOR_GRAY_2">{label}</TextNew>
//     <TextNew fontSize={13} fontWeight={isBold ? "bold" : "500"} color="BLACK" textAlign="right" flex={1} >
//       {value || 'N/A'}
//     </TextNew>
//   </Box>
// )

// import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
// import { useRoute, RouteProp } from '@react-navigation/core'
// import { useNavigation } from '@react-navigation/native'
// import React, { useEffect, useState } from 'react'
// import { AepsButton } from '../../comps/AepsButton'
// import { Container } from '../../comps/Container'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { Screens } from '../../nav/Screens'
// import { BbpsStackParamList } from '../../nav/Bbps'
// import { BackHandler, Platform, StyleSheet, View, Image, ImageSourcePropType } from 'react-native'

// const Row = ({ label, value }: any) => (
//   <Box flexDirection="row" justifyContent="space-between" mb={5}>
//     <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1">
//       {label}
//     </TextNew>
//     <TextNew fontSize={13} fontWeight="500">
//       {value || 'N/A'}
//     </TextNew>
//   </Box>
// )

// const DetailLine = ({ label, value }: any) => (
//   <Box flexDirection="row" justifyContent="space-between">
//     <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//       {label}
//     </TextNew>
//     <TextNew fontSize={12}>{value || 'N/A'}</TextNew>
//   </Box>
// )

// const DetailRow = ({ label, value, isLast = false }: any) => (
//   <Box
//     flexDirection="row"
//     justifyContent="space-between"
//     pv={12}
//     borderBottomWidth={isLast ? 0 : 1}
//     borderColor="WHITE">
//     <TextNew fontSize={14} color="BRAND_COLOR_GRAY_2">
//       {label}
//     </TextNew>
//     <TextNew fontSize={14} fontWeight="500" color="BLACK" textAlign="right" flex={1}>
//       {value || 'N/A'}
//     </TextNew>
//   </Box>
// )

// type TransactionSuccessRouteProp = RouteProp<BbpsStackParamList, typeof Screens.TRANSACTION_DETAILS>

// export const TransactionDetails = () => {
//   // const route = useRoute<TransactionSuccessRouteProp>()
//   const route = useRoute<any>()
//   const navigation = useNavigation<any>()
//   const { orderId, message, status, billDetails } = route.params || {}
//   const [showDetailsDrawer, setShowDetailsDrawer] = useState(false)

//   const formatDate = (dateStr: string) => {
//     if (!dateStr) return 'N/A'
//     const date = new Date(dateStr)
//     // use toLocaleString instead of toLocaleDateString
//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true, // Forces AM/PM format
//     })
//   }

//   const bill = billDetails?.bill
//   const product = billDetails?.order?.product
//   const billerisBbps = billDetails?.order?.product?.isBbps
//   const payment = billDetails?.order?.payment
//   const paymentId = billDetails?.order?.payment?.id
//   const paymentAt = billDetails?.order?.payment?.paymentAt
//   const formattedPaymentDate = formatDate(paymentAt)
//   const transactionData = billDetails?.order || {}
//   const paymentInfo = transactionData?.payment || {}
//   const productInfo = transactionData?.product || {}
//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
//   const amount = payment?.amountDetails?.netAmount || '0.00'

//   useEffect(() => {
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onDonePress = () => {
//     // navigation.popToTop()
//     navigation.reset({
//       index: 0,
//       routes: [{ name: Screens.BBPS_HOME_SCREEN as any }],
//     })
//   }

//   const handleViewDetails = () => {
//     navigation.navigate(Screens.VIEW_DETAILS, {
//       billDetails: billDetails,
//     })
//     // navigation.reset({
//     //   index: 0,
//     //   routes: [{ name: Screens.VIEW_DETAILS as any }],
//     // })
//   }

//   return (
//     <Container showFooter={false} overflow="auto">
//       <>
//         <Box overflow={'auto'}>
//           <Box width={'100%'} justifyContent={'space-between'} height={'100%'}>
//             <Box marginBottom={10}>
//               <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={30} />
//             </Box>
//             <TextNew fontSize={25} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//               {'Bill Payment Successful'}
//             </TextNew>
//             {/* <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
//               {message || 'Your bill payment has been processed.'}
//             </TextNew> */}

//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//             <Box width={'100%'}>
//               <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                   {product?.name || 'BBPS Biller'}
//                   {/* {'Bank of Test- Fastag Test'} */}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                   {'Amount'}
//                 </TextNew>
//               </Box>
//               <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                 {/* <Row label="Customer Name" value={bill?.customerName} />

//                 <Row
//                   label={product?.attribute?.labelOfAuthenticators?.[0] || 'ID'}
//                   value={product?.attribute?.authenticatorList?.[0]}
//                 /> */}

//                 {/* <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                   {product?.attribute?.labelOfAuthenticators?.[0] || 'ID'}
//                 </TextNew> */}
//                 <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                   {product?.attribute?.authenticatorList?.[0]}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                   {amount}
//                 </TextNew>
//               </Box>
//             </Box>

//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />

//             <Box marginTop={8} marginBottom={8} flexDirection={'row'} gap={40}>
//               <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                 {"The payment will reflect at biller's end after 2-3 working day's"}
//               </TextNew>
//               <Icon id={'TIMER'} color="BRAND_COLOR_GRAY_1" size={16} />
//             </Box>
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />

//             {/* <Box width={'50%'}>
//               <AepsButton onPress={handleViewDetails()} title={'View Details'} disabled={false} />
//             </Box> */}
//             <Box onPress={() => handleViewDetails()}>
//               <TextNew fontSize={16} lineHeight={28} color="BRAND_PRIMARY_ACTION">
//                 {'View Details'}
//               </TextNew>
//             </Box>

//             <Box marginTop={20} marginBottom={20} backgroundColor="WHITE" padding={20}>
//               <Box paddingBottom={20}>
//                 <TextNew fontSize={16} lineHeight={28} fontWeight={'BOLD'} color="BRAND_COLOR_GRAY_1">
//                   {'Amount to be Paid by Customer'}
//                 </TextNew>
//               </Box>
//               <Box
//                 borderStyle={'dashed'}
//                 borderTopWidth={1}
//                 borderColor={'PRIMARY_GREY'}
//                 width={'100%'}
//                 paddingBottom={15}
//               />
//               <Box flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
//                 <Box>
//                   <TextNew fontSize={22} lineHeight={28} fontWeight={'BOLD'} color="BRAND_COLOR_GRAY_1">
//                     ₹ {payment?.amountDetails?.netAmount || '0.00'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {'*inc. Agent fee'}
//                   </TextNew>
//                 </Box>
//                 <Box onPress={() => setShowDetailsDrawer(true)}>
//                   <TextNew fontSize={16} lineHeight={28} color="BRAND_PRIMARY_ACTION">
//                     {'view breakup'}
//                   </TextNew>
//                   <Icon id="ARROW_DOWN" color="BRAND_PRIMARY_ACTION" size={12} />
//                 </Box>
//               </Box>
//             </Box>
//             <Box width={'100%'}>
//               <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
//               <Box flexDirection="row" align="center" justify="center">
//                 <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//                   Powered by
//                 </TextNew>
//                 <SpacerNew direction="horizontal" size={8} />
//                 <Image source={BBPSLogo} style={{ width: 80, height: 24, resizeMode: 'contain' }} />
//               </Box>
//             </Box>
//             {/* <Box flexDirection="row" justifyContent="space-between" width={'100%'} alignItems="center">
//               <Box width={'50%'} alignItems="center" marginBottom={10}>
//                 <AepsButton onPress={() => setShowDetailsDrawer(true)} title={'View Receipt Details'} />
//               </Box>
//               <Box width={'50%'} alignItems="center" marginBottom={10}>
//                 <AepsButton onPress={onDonePress} title={'Done'} />
//               </Box>
//             </Box> */}
//           </Box>
//         </Box>
//         <VerticleDrawerDialog
//           show={showDetailsDrawer}
//           // message="You have been inactive for some time. Please log in again."
//           type="POSITIVE"
//           message="You have been inactive for some time. Please log in again."
//           onPress={() => setShowDetailsDrawer(false)}>
//           <Box width={'100%'}>
//             <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={16} />
//             <Box gap={10}>
//               <TextNew fontSize={24} lineHeight={28} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                 ₹ {payment?.amountDetails?.netAmount || '0.00'}
//               </TextNew>
//               <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                 {product?.name || 'BBPS Biller'}
//               </TextNew>
//               <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                 {formatDate(paymentAt)}
//               </TextNew>
//             </Box>
//             <Box marginBottom={20} marginTop={20} customShadowStyle="shadowPrimary" padding={15} gap={12}>
//               <Box
//                 flexDirection={'row'}
//                 justifyContent={'space-between'}
//                 alignItems={'center'}
//                 shadowColor={'BLACK_GRAY_SHADE'}
//                 marginBottom={20}>
//                 <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                   {'Transaction Details'}
//                 </TextNew>
//                 <Icon id={'INFO'} color="AVAILABLE_GREEN" size={30} />
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Biller'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {product?.name || 'BBPS Biller'}
//                 </TextNew>
//               </Box>
//               {/* <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Utr Number'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'139786275'}
//                 </TextNew>
//               </Box> */}
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Agent Commission'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   ₹ {'0.00'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Amount'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   ₹ {payment?.amountDetails?.netAmount || '0.00'}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                   {'*inc. Agent fee'}
//                 </TextNew>
//               </Box>

//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {orderId}

//                   {/* {'TXN4057044156566'} */}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'BBPS Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {paymentId}
//                   {/* {'JIO14057000000002H386'} */}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Payment At'}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                   {formatDate(paymentAt)}
//                 </TextNew>
//               </Box>
//               {/* <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Paid by'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'UPI'}
//                 </TextNew>
//               </Box> */}
//             </Box>
//           </Box>
//         </VerticleDrawerDialog>
//       </>
//     </Container>
//   )
// }

// import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
// import { useRoute, RouteProp } from '@react-navigation/core'
// import { useNavigation } from '@react-navigation/native'
// import React, { useEffect, useState } from 'react'
// import { AepsButton } from '../../comps/AepsButton'
// import { Container } from '../../comps/Container'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { Screens } from '../../nav/Screens'
// import { BbpsStackParamList } from '../../nav/Bbps'
// import { BackHandler, Platform, StyleSheet, View, Image, ImageSourcePropType } from 'react-native'

// export const TransactionDetails = () => {
//   const route = useRoute<any>()
//   const navigation = useNavigation<any>()
//   const { orderId, billDetails } = route.params || {}
//   const [showDetailsDrawer, setShowDetailsDrawer] = useState(false)

//   const formatDate = (dateStr: string) => {
//     if (!dateStr) return 'N/A'
//     const date = new Date(dateStr)
//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true,
//     })
//   }

//   const product = billDetails?.order?.product
//   const payment = billDetails?.order?.payment
//   const paymentId = billDetails?.order?.payment?.id
//   const paymentAt = billDetails?.order?.payment?.paymentAt
//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
//   const amount = payment?.amountDetails?.netAmount || '0.00'

//   useEffect(() => {
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onDonePress = () => {
//     navigation.reset({
//       index: 0,
//       routes: [{ name: Screens.BBPS_HOME_SCREEN as any }],
//     })
//   }

//   const handleViewDetails = () => {
//     navigation.navigate(Screens.VIEW_DETAILS, { billDetails })
//   }

//   return (
//     <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
//       <Box flex={1} padding={20}>
//         <Box width={'100%'} justifyContent={'space-between'} height={'100%'}>

//           {/* Status Header - Professional spacing and alignment */}
//           <Box alignItems="center" mt={30} mb={20}>
//             <Box backgroundColor="WHITE" borderRadius={50} padding={12} customShadowStyle="shadowPrimary">
//               <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={40} />
//             </Box>
//             <SpacerNew size={16} />
//             <TextNew fontSize={22} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//               {'Bill Payment Successful'}
//             </TextNew>
//           </Box>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'}  />

//           {/* Primary Transaction Info Row */}
//           <Box width={'100%'} mb={15}>
//             <Box flexDirection={'row'} justifyContent={'space-between'} mb={8}>
//               <TextNew fontSize={12} color="DARK_GREY">
//                 {'Biller Name'}
//               </TextNew>
//               <TextNew fontSize={12} color="DARK_GREY">
//                 {'Bill Amount'}
//               </TextNew>
//             </Box>
//             <Box flexDirection={'row'} justifyContent={'space-between'} alignItems="flex-end">
//               <Box flex={1} mr={10}>
//                 <TextNew fontSize={16} color="BLACK" fontWeight={'500'} numberOfLines={1}>
//                   {product?.name || 'BBPS Biller'}
//                 </TextNew>
//                 <TextNew fontSize={13} color="PRIMARY_GREY">
//                   {product?.attribute?.authenticatorList?.[0]}
//                 </TextNew>
//               </Box>
//               <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                 ₹{amount}
//               </TextNew>
//             </Box>
//           </Box>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//           {/* User Feedback/Status Box */}
//           <Box
//             flexDirection={'row'}
//             alignItems={'center'}
//             backgroundColor="WHITE"
//             padding={12}
//             borderRadius={8}
//             borderWidth={1}
//             borderColor="BORDER_COLOR"
//           >
//             <Box flex={1}>
//               <TextNew fontSize={11} lineHeight={16} color="DARK_GREY">
//                 {"Note: The payment will reflect at biller's end after 2-3 working days."}
//               </TextNew>
//             </Box>
//             <SpacerNew direction="horizontal" size={10} />
//             <Icon id={'TIMER'} color="TINY_GREY" size={18} />
//           </Box>

//           <Box mt={20} alignItems="center">
//             <Box onPress={handleViewDetails} padding={8}>
//               <TextNew fontSize={14} color="PRIMARY" fontWeight={'500'}>
//                 {'View Receipt Details'}
//               </TextNew>
//             </Box>
//           </Box>

//           {/* Amount Summary Card */}
//           <Box backgroundColor="WHITE" padding={20} borderRadius={12} customShadowStyle="shadowPrimary">
//             <TextNew fontSize={14} fontWeight={'FONT_WEIGHT_BOLD'} color="PRIMARY_GREY" >
//               {'Amount Paid'}
//             </TextNew>

//             <Box flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
//               <Box>
//                 <TextNew fontSize={26} fontWeight={'FONT_WEIGHT_BOLD'} color="BLACK">
//                   ₹{amount}
//                 </TextNew>
//                 <TextNew fontSize={10} color="PRIMARY_GREY">
//                   {'*inclusive of Agent fee'}
//                 </TextNew>
//               </Box>
//               <Box
//                 onPress={() => setShowDetailsDrawer(true)}
//                 flexDirection="row"
//                 alignItems="center"
//                 backgroundColor="ALTO_DISABLED"
//                 padding={8}
//                 borderRadius={6}
//               >
//                 <TextNew fontSize={12} color="PRIMARY" fontWeight={'500'} >
//                   {'BREAKUP'}
//                 </TextNew>
//                 <Icon id="ARROW_DOWN" color="PRIMARY" size={12} />
//               </Box>
//             </Box>
//           </Box>

//           {/* Footer Actions */}
//           <Box width={'100%'} mt="auto">
//             <AepsButton onPress={onDonePress} title={'Done'} />
//             <Box flexDirection="row" align="center" justify="center" pt={20} pb={10}>
//               <TextNew fontSize={11} color="TINY_GREY">
//                 Powered by
//               </TextNew>
//               <SpacerNew direction="horizontal" size={8} />
//               <Image source={BBPSLogo} style={{ width: 60, height: 18, resizeMode: 'contain' }} />
//             </Box>
//           </Box>
//         </Box>
//       </Box>

//       {/* Breakup Drawer Refined with Theme Colors */}
//       <VerticleDrawerDialog
//         show={showDetailsDrawer}
//         type="POSITIVE"
//         message=""
//         onPress={() => setShowDetailsDrawer(false)}>
//         <Box width={'100%'} paddingBottom={20}>
//           <Box flexDirection="row" alignItems="center" mb={20}>
//             <Icon id={'INFO'} color="PRIMARY" size={20} />
//             <SpacerNew direction="horizontal" size={12} />
//             <TextNew fontSize={18} fontWeight={'FONT_WEIGHT_BOLD'}>Transaction Breakup</TextNew>
//           </Box>

//           <Box gap={16}>
//              <DetailItem label="Biller Name" value={product?.name} />
//              <DetailItem label="Transaction ID" value={orderId} />
//              <DetailItem label="BBPS Ref No." value={paymentId} />
//              <DetailItem label="Paid On" value={formatDate(paymentAt)} />
//              <Box borderTopWidth={1} borderColor="GREY_SEPARATOR" pt={12} mt={4} flexDirection="row" justifyContent="space-between">
//                 <TextNew fontWeight={'FONT_WEIGHT_BOLD'}>Total Paid</TextNew>
//                 <TextNew fontWeight={'FONT_WEIGHT_BOLD'} color="AVAILABLE_GREEN">₹{amount}</TextNew>
//              </Box>
//           </Box>
//         </Box>
//       </VerticleDrawerDialog>
//     </Container>
//   )
// }

// // Clean helper for drawer items
// const DetailItem = ({ label, value }: any) => (
//   <Box flexDirection="row" justifyContent="space-between">
//     <TextNew fontSize={13} color="PRIMARY_GREY">{label}</TextNew>
//     <TextNew fontSize={13} fontWeight={'500'} color="BLACK" textAlign="right" flex={1} >{value || 'N/A'}</TextNew>
//   </Box>
// )

// import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
// import { useRoute, RouteProp } from '@react-navigation/core'
// import { useNavigation } from '@react-navigation/native'
// import React, { useEffect, useState } from 'react'
// import { AepsButton } from '../../comps/AepsButton'
// import { Container } from '../../comps/Container'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { Screens } from '../../nav/Screens'
// import { BbpsStackParamList } from '../../nav/Bbps'
// import { BackHandler, Platform, StyleSheet, View, Image, ImageSourcePropType } from 'react-native'

// const Row = ({ label, value }: any) => (
//   <Box flexDirection="row" justifyContent="space-between" mb={5}>
//     <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1">
//       {label}
//     </TextNew>
//     <TextNew fontSize={13} fontWeight="500">
//       {value || 'N/A'}
//     </TextNew>
//   </Box>
// )

// const DetailLine = ({ label, value }: any) => (
//   <Box flexDirection="row" justifyContent="space-between">
//     <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//       {label}
//     </TextNew>
//     <TextNew fontSize={12}>{value || 'N/A'}</TextNew>
//   </Box>
// )

// const DetailRow = ({ label, value, isLast = false }: any) => (
//   <Box
//     flexDirection="row"
//     justifyContent="space-between"
//     pv={12}
//     borderBottomWidth={isLast ? 0 : 1}
//     borderColor="WHITE">
//     <TextNew fontSize={14} color="BRAND_COLOR_GRAY_2">
//       {label}
//     </TextNew>
//     <TextNew fontSize={14} fontWeight="500" color="BLACK" textAlign="right" flex={1}>
//       {value || 'N/A'}
//     </TextNew>
//   </Box>
// )

// type TransactionSuccessRouteProp = RouteProp<BbpsStackParamList, typeof Screens.TRANSACTION_DETAILS>

// export const TransactionDetails = () => {
//   // const route = useRoute<TransactionSuccessRouteProp>()
//   const route = useRoute<any>()
//   const navigation = useNavigation<any>()
//   const { orderId, message, status, billDetails } = route.params || {}
//   const [showDetailsDrawer, setShowDetailsDrawer] = useState(false)

//   const formatDate = (dateStr: string) => {
//     if (!dateStr) return 'N/A'
//     const date = new Date(dateStr)
//     // use toLocaleString instead of toLocaleDateString
//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true, // Forces AM/PM format
//     })
//   }

//   const bill = billDetails?.bill
//   const product = billDetails?.order?.product
//   const billerisBbps = billDetails?.order?.product?.isBbps
//   const payment = billDetails?.order?.payment
//   const paymentId = billDetails?.order?.payment?.id
//   const paymentAt = billDetails?.order?.payment?.paymentAt
//   const formattedPaymentDate = formatDate(paymentAt)
//   const transactionData = billDetails?.order || {}
//   const paymentInfo = transactionData?.payment || {}
//   const productInfo = transactionData?.product || {}
//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
//   const amount = payment?.amountDetails?.netAmount || '0.00'

//   useEffect(() => {
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onDonePress = () => {
//     // navigation.popToTop()
//     navigation.reset({
//       index: 0,
//       routes: [{ name: Screens.BBPS_HOME_SCREEN as any }],
//     })
//   }

//   const handleViewDetails = () => {
//     navigation.navigate(Screens.VIEW_DETAILS, {
//       billDetails: billDetails,
//     })
//     // navigation.reset({
//     //   index: 0,
//     //   routes: [{ name: Screens.VIEW_DETAILS as any }],
//     // })
//   }

//   return (
//     <Container showFooter={false} overflow="auto">
//       <>
//         <Box overflow={'auto'}>
//           <Box width={'100%'} justifyContent={'space-between'} height={'100%'}>
//             <Box marginBottom={10}>
//               <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={30} />
//             </Box>
//             <TextNew fontSize={25} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//               {'Bill Payment Successful'}
//             </TextNew>
//             {/* <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
//               {message || 'Your bill payment has been processed.'}
//             </TextNew> */}

//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//             <Box width={'100%'}>
//               <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                   {product?.name || 'BBPS Biller'}
//                   {/* {'Bank of Test- Fastag Test'} */}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                   {'Amount'}
//                 </TextNew>
//               </Box>
//               <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                 {/* <Row label="Customer Name" value={bill?.customerName} />

//                 <Row
//                   label={product?.attribute?.labelOfAuthenticators?.[0] || 'ID'}
//                   value={product?.attribute?.authenticatorList?.[0]}
//                 /> */}

//                 {/* <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                   {product?.attribute?.labelOfAuthenticators?.[0] || 'ID'}
//                 </TextNew> */}
//                 <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                   {product?.attribute?.authenticatorList?.[0]}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                   {amount}
//                 </TextNew>
//               </Box>
//             </Box>

//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />

//             <Box marginTop={8} marginBottom={8} flexDirection={'row'} gap={40}>
//               <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                 {"The payment will reflect at biller's end after 2-3 working day's"}
//               </TextNew>
//               <Icon id={'TIMER'} color="BRAND_COLOR_GRAY_1" size={16} />
//             </Box>
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />

//             {/* <Box width={'50%'}>
//               <AepsButton onPress={handleViewDetails()} title={'View Details'} disabled={false} />
//             </Box> */}
//             <Box onPress={() => handleViewDetails()}>
//               <TextNew fontSize={16} lineHeight={28} color="BRAND_PRIMARY_ACTION">
//                 {'View Details'}
//               </TextNew>
//             </Box>

//             <Box marginTop={20} marginBottom={20} backgroundColor="WHITE" padding={20}>
//               <Box paddingBottom={20}>
//                 <TextNew fontSize={16} lineHeight={28} fontWeight={'BOLD'} color="BRAND_COLOR_GRAY_1">
//                   {'Amount to be Paid by Customer'}
//                 </TextNew>
//               </Box>
//               <Box
//                 borderStyle={'dashed'}
//                 borderTopWidth={1}
//                 borderColor={'PRIMARY_GREY'}
//                 width={'100%'}
//                 paddingBottom={15}
//               />
//               <Box flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
//                 <Box>
//                   <TextNew fontSize={22} lineHeight={28} fontWeight={'BOLD'} color="BRAND_COLOR_GRAY_1">
//                     ₹ {payment?.amountDetails?.netAmount || '0.00'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {'*inc. Agent fee'}
//                   </TextNew>
//                 </Box>
//                 <Box onPress={() => setShowDetailsDrawer(true)}>
//                   <TextNew fontSize={16} lineHeight={28} color="BRAND_PRIMARY_ACTION">
//                     {'view breakup'}
//                   </TextNew>
//                   <Icon id="ARROW_DOWN" color="BRAND_PRIMARY_ACTION" size={12} />
//                 </Box>
//               </Box>
//             </Box>
//             <Box width={'100%'}>
//               <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
//               <Box flexDirection="row" align="center" justify="center">
//                 <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//                   Powered by
//                 </TextNew>
//                 <SpacerNew direction="horizontal" size={8} />
//                 <Image source={BBPSLogo} style={{ width: 80, height: 24, resizeMode: 'contain' }} />
//               </Box>
//             </Box>
//             {/* <Box flexDirection="row" justifyContent="space-between" width={'100%'} alignItems="center">
//               <Box width={'50%'} alignItems="center" marginBottom={10}>
//                 <AepsButton onPress={() => setShowDetailsDrawer(true)} title={'View Receipt Details'} />
//               </Box>
//               <Box width={'50%'} alignItems="center" marginBottom={10}>
//                 <AepsButton onPress={onDonePress} title={'Done'} />
//               </Box>
//             </Box> */}
//           </Box>
//         </Box>
//         <VerticleDrawerDialog
//           show={showDetailsDrawer}
//           // message="You have been inactive for some time. Please log in again."
//           type="POSITIVE"
//           message="You have been inactive for some time. Please log in again."
//           onPress={() => setShowDetailsDrawer(false)}>
//           <Box width={'100%'}>
//             <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={16} />
//             <Box gap={10}>
//               <TextNew fontSize={24} lineHeight={28} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                 ₹ {payment?.amountDetails?.netAmount || '0.00'}
//               </TextNew>
//               <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                 {product?.name || 'BBPS Biller'}
//               </TextNew>
//               <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                 {formatDate(paymentAt)}
//               </TextNew>
//             </Box>
//             <Box marginBottom={20} marginTop={20} customShadowStyle="shadowPrimary" padding={15} gap={12}>
//               <Box
//                 flexDirection={'row'}
//                 justifyContent={'space-between'}
//                 alignItems={'center'}
//                 shadowColor={'BLACK_GRAY_SHADE'}
//                 marginBottom={20}>
//                 <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                   {'Transaction Details'}
//                 </TextNew>
//                 <Icon id={'INFO'} color="AVAILABLE_GREEN" size={30} />
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Biller'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {product?.name || 'BBPS Biller'}
//                 </TextNew>
//               </Box>
//               {/* <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Utr Number'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'139786275'}
//                 </TextNew>
//               </Box> */}
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Agent Commission'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   ₹ {'0.00'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Amount'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   ₹ {payment?.amountDetails?.netAmount || '0.00'}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                   {'*inc. Agent fee'}
//                 </TextNew>
//               </Box>

//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {orderId}

//                   {/* {'TXN4057044156566'} */}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'BBPS Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {paymentId}
//                   {/* {'JIO14057000000002H386'} */}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Payment At'}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                   {formatDate(paymentAt)}
//                 </TextNew>
//               </Box>
//               {/* <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Paid by'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'UPI'}
//                 </TextNew>
//               </Box> */}
//             </Box>
//           </Box>
//         </VerticleDrawerDialog>
//       </>
//     </Container>
//   )
// }

// <Box marginBottom={20} marginTop={20} customShadowStyle="shadowPrimary" padding={15} gap={12}>
//             <Box
//               flexDirection={'row'}
//               justifyContent={'space-between'}
//               alignItems={'center'}
//               shadowColor={'BLACK_GRAY_SHADE'}
//               marginBottom={20}>
//               <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                 {'Transaction Details'}
//               </TextNew>
//               <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//             </Box>
//             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//               <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                 {'Biller'}
//               </TextNew>
//               <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                 {product?.name || 'BBPS Biller'}
//                 {/* {'Mobile Recharge Bill Payments'} */}
//               </TextNew>
//             </Box>
//             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//               <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                 {'Utr Number'}
//               </TextNew>
//               <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                 {'139786275'}
//               </TextNew>
//             </Box>
//             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//               <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                 {'Transaction ID'}
//               </TextNew>
//               <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                 {'TXN4057044156566'}
//               </TextNew>
//             </Box>
//             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//               <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                 {'BBPS Transaction ID'}
//               </TextNew>
//               <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                 {'JIO14057000000002H386'}
//               </TextNew>
//             </Box>
//             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//               <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                 {'Paid by'}
//               </TextNew>
//               <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                 {'UPI'}
//               </TextNew>
//             </Box>
//           </Box>

// return (
//   <Container showFooter={true} overflow="auto">
//     <Box padding={20} height="100%" justifyContent="space-between">
//       <Box>
//         {/* Success Header */}
//         <Box alignItems="center" gap={10} marginBottom={20}>
//           <Icon id={'SUCCESSFUL_FILLED'} color="AVAILABLE_GREEN" size={60} />
//           <TextNew fontSize={24} color="BLACK" fontWeight={'bold'}>
//             Bill Payment Successful
//           </TextNew>
//           <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
//             {message || 'Your bill payment has been processed.'}
//           </TextNew>
//         </Box>

//         <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} mb={20} />

//         <Box backgroundColor="WHITE" p={16} borderRadius={12} mb={20}>
//           <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//             BILLER
//           </TextNew>
//           <TextNew fontSize={16} fontWeight="bold">
//             {product?.name || 'BBPS Biller'}
//           </TextNew>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} mb={10} />

//           <Row label="Customer Name" value={bill?.customerName} />
//           <Row
//             label={product?.attribute?.labelOfAuthenticators?.[0] || 'ID'}
//             value={product?.attribute?.authenticatorList?.[0]}
//           />

//           <Box mt={10} flexDirection="row" justifyContent="space-between">
//             <TextNew fontSize={14} fontWeight="bold">
//               Total Paid
//             </TextNew>
//             <TextNew fontSize={16} fontWeight="bold" color="AVAILABLE_GREEN">
//               ₹ {payment?.amountDetails?.netAmount || '0.00'}
//             </TextNew>
//           </Box>
//         </Box>

//         {/* Transaction Meta Info */}
//         <Box gap={10} px={5}>
//           <DetailLine label="Transaction ID" value={payment?.id} />
//           <DetailLine label="BBPS Ref No" value={product?.bbpsRegNo} />
//           <DetailLine label="Order ID" value={orderId} />
//           <DetailLine label="Payment Mode" value={payment?.paymentInstrument} />
//         </Box>

//         {/* Quick Info */}
//         <Box gap={12}>
//           <Box flexDirection="row" justifyContent="space-between">
//             <TextNew color="BRAND_COLOR_GRAY_1">Order ID</TextNew>
//             <TextNew fontWeight="bold">{orderId}</TextNew>
//           </Box>
//           <Box flexDirection="row" justifyContent="space-between">
//             <TextNew color="BRAND_COLOR_GRAY_1">Status</TextNew>
//             <TextNew color="AVAILABLE_GREEN" fontWeight="bold">
//               SUCCESS
//             </TextNew>
//           </Box>
//         </Box>

//         <SpacerNew />
//         <Box flexDirection="row" justifyContent="space-between" width={'100%'} alignItems="center">
//           <Box width={'50%'} alignItems="center" marginBottom={10}>
//             <AepsButton onPress={() => setShowDetailsDrawer(true)} title={'View Receipt Details'} />
//           </Box>
//           <Box width={'50%'} alignItems="center" marginBottom={10}>
//             <AepsButton onPress={onDonePress} title={'Done'} />
//           </Box>
//         </Box>

//         <Box
//           mt={30}
//           p={15}
//           backgroundColor="BG_WHITE"
//           borderRadius={8}
//           borderLeftWidth={4}
//           borderLeftColor="AVAILABLE_GREEN">
//           <TextNew fontSize={12} color="BLACK">
//             Note: The payment will reflect at the biller's end within 2-3 working days as per BBPS guidelines.
//           </TextNew>
//         </Box>
//       </Box>

//       <Box mt="auto" mb={30} align="center" width="100%">
//         <Box flexDirection="row" align="center" justify="center" mb={12}>
//           <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//             Powered by
//           </TextNew>
//           <SpacerNew direction="horizontal" size={8} />
//           <Image source={BBPSLogo} style={{ width: 80, height: 24, resizeMode: 'contain' }} />
//         </Box>
//       </Box>

//       {/* Receipt Details Drawer */}
//       <VerticleDrawerDialog
//         show={showDetailsDrawer}
//         type="POSITIVE"
//         message="You have been inactive for some time. Please log in again."
//         onPress={() => setShowDetailsDrawer(false)}>
//         <Box width={'100%'} padding={10} gap={15}>
//           <Box alignItems="center" mb={20}>
//             <Icon id={'SUCCESSFUL_FILLED'} color="AVAILABLE_GREEN" size={40} />
//             <TextNew fontSize={20} fontWeight="bold">
//               Transaction Receipt
//             </TextNew>
//           </Box>

//           <Box gap={15} backgroundColor="WHITE" p={15} borderRadius={10} customShadowStyle="shadowPrimary">
//             <DetailRow label="Biller Name" value="BBPS Biller" />
//             <DetailRow label="Order ID" value={orderId} />
//             <DetailRow label="Date" value={new Date().toLocaleDateString()} />
//             <DetailRow label="Payment Mode" value="Wallet/UPI" />
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} my={5} />
//             <DetailRow label="Total Amount" value={`₹ ${route.params?.amount || '0.00'}`} isBold />
//           </Box>
//         </Box>
//       </VerticleDrawerDialog>
//     </Box>
//   </Container>
// )

// import { Box, Icon, TextNew } from '@jfs/ui-new'
// import { useRoute } from '@react-navigation/core'
// import { useNavigation } from '@react-navigation/native'
// import { useEffect, useState } from 'react'
// import { AepsButton } from '../../comps/AepsButton'
// import { Container } from '../../comps/Container'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { Screens } from '../../nav/Screens'

// export const TransactionDetails = () => {
//   const route = useRoute<any>()
//   const navigation = useNavigation<any>()

//   const { status, orderId, message, amount, billerName } = route.params || {}

//   const [showInactivityDialog, setShowInactivityDialog] = useState(false)

//       useEffect(() => {
//           // 2. Clear sensitive polling data from storage once we hit this terminal screen
//           localStorage.removeItem('pending_order_value');
//           sessionStorage.removeItem('pending_order_value');
//       }, [])

//   const onPrimaryButtonPress = () => {
//     setOpenConfirmDialog(true)
//     navigation.navigate(Screens.BBPS_HOME_SCREEN as never)
//   }

//   const handleViewDetails = () => {
//     setShowInactivityDialog(true)
//   }

//   const [activeTab, setActiveTab] = useState('payBills')
//   const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
//   const [checked, setChecked] = useState(false)
//   const routes = useRoute()

//   const handleInactivityDialogPress = () => {
//     setShowInactivityDialog(false)
//   }

//   const searchList = (tnxId) => {
//     console.log(tnxId)
//   }

//   const handlePress = () => {
//     setShowInactivityDialog(true)
//     console.log('enter something here.')
//   }

//   return (
//     <Container showFooter={true} overflow="auto">
//       <>
//                 {/* <Box width={'100%'} justifyContent={'space-between'} height={'100%'} > */}
//         <Box overflow={'auto'}>
//           {/* <VerticleDrawerDialog
//                         show={showInactivityDialog}
//                         // message="You have been inactive for some time. Please log in again."
//                         type="POSITIVE"
//                         onPress={handleInactivityDialogPress}
//                     > */}
//           <Box gap={15}>
//             <Box>
//               <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//             </Box>
//             <TextNew fontSize={25} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//               {'Bill Payment Successfull'}
//             </TextNew>
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//             <Box width={'100%'}>
//               <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                   {'Bank of Test- Fastag Test'}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                   {'Amount'}
//                 </TextNew>
//               </Box>
//               <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                 <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                   {'TS21TR5456'}
//                 </TextNew>
//                 <TextNew fontSize={12} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                   {'3000.000'}
//                 </TextNew>
//               </Box>
//             </Box>
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//             <Box marginTop={8} marginBottom={8} flexDirection={'row'} gap={40}>
//               <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                 {"The payment will reflect at biller's end after 2-3 working day's"}
//               </TextNew>
//               <Icon id={'CHECKBOX_OUTLINE'} color="AVAILABLE_GREEN" size={16} />
//             </Box>
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//             <Box width={'50%'}>
//               <AepsButton onPress={handlePress} title={'View Details'} disabled={false} />
//             </Box>
//             <Box marginTop={20} marginBottom={20} backgroundColor="BRAND_PRIMARY_RED" padding={20}>
//               <Box paddingBottom={20}>
//                 <TextNew fontSize={16} lineHeight={28} fontWeight={'BOLD'} color="BRAND_COLOR_GRAY_1">
//                   {'Amount to be Paid by Customer'}
//                 </TextNew>
//               </Box>
//               <Box
//                 borderStyle={'dashed'}
//                 borderTopWidth={1}
//                 borderColor={'PRIMARY_GREY'}
//                 width={'100%'}
//                 paddingBottom={15}
//               />
//               <Box flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
//                 <Box>
//                   <TextNew fontSize={22} lineHeight={28} fontWeight={'BOLD'} color="BRAND_COLOR_GRAY_1">
//                     {'305.00'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {'*inc. Agent fee'}
//                   </TextNew>
//                 </Box>
//                 <Box>
//                   <TextNew fontSize={16} lineHeight={28} color="BRAND_PRIMARY_ACTION">
//                     {'view breakup'}
//                   </TextNew>
//                 </Box>
//               </Box>
//             </Box>
//             <Box width={'100%'} marginTop={20}>
//               <AepsButton onPress={onPrimaryButtonPress} title={'Done'} disabled={false} />
//             </Box>
//           </Box>
//         </Box>
//         <VerticleDrawerDialog
//           show={showInactivityDialog}
//           message="You have been inactive for some time. Please log in again."
//           type="POSITIVE"
//           onPress={handleInactivityDialogPress}>
//           <Box width={'100%'}>
//             <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={16} />
//             <Box gap={10}>
//               <TextNew fontSize={24} lineHeight={28} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                 {'300.000'}
//               </TextNew>
//               <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                 {'Mobile Recharge Bill Payments'}
//               </TextNew>
//               <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                 {'26 Feb 2024, 05:44 PM'}
//               </TextNew>
//             </Box>
//             <Box marginBottom={20} marginTop={20} customShadowStyle="shadowPrimary" padding={15} gap={12}>
//               <Box
//                 flexDirection={'row'}
//                 justifyContent={'space-between'}
//                 alignItems={'center'}
//                 shadowColor={'BLACK_GRAY_SHADE'}
//                 marginBottom={20}>
//                 <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                   {'Transaction Details'}
//                 </TextNew>
//                 <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Biller'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'Mobile Recharge Bill Payments'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Utr Number'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'139786275'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'TXN4057044156566'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'BBPS Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'JIO14057000000002H386'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Paid by'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'UPI'}
//                 </TextNew>
//               </Box>
//             </Box>
//             <Box marginBottom={20} marginTop={20} customShadowStyle="shadowPrimary" padding={15} gap={12}>
//               <Box
//                 flexDirection={'row'}
//                 justifyContent={'space-between'}
//                 alignItems={'center'}
//                 shadowColor={'BLACK_GRAY_SHADE'}
//                 marginBottom={20}>
//                 <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                   {'Transaction Details'}
//                 </TextNew>
//                 <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Biller'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'Mobile Recharge Bill Payments'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Utr Number'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'139786275'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'TXN4057044156566'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'BBPS Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'JIO14057000000002H386'}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Paid by'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {'UPI'}
//                 </TextNew>
//               </Box>
//             </Box>
//           </Box>
//         </VerticleDrawerDialog>
//       </>
//     </Container>
//   )
// }

// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useState, useEffect } from 'react'
// import { InactivityDialog } from '../../comps/InactivityDialog'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { ServiceHighlights } from '../../comps/ServiceHighlight'
// import { IconWithText } from '../../comps/IconWithText'
// import { AepsCheckBox } from '../../comps/AepsCheckBox'
// import { AepsButton } from '../../comps/AepsButton'
// import { flex } from 'styled-system'
// import { RowItem } from '../../comps/RowItem'
// import { useNavigation } from '@react-navigation/native'
// import { useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'

// // Mock data and functions to simulate a dynamic component
// const useLazyApiData = (apiFn) => {
//     const [data, setData] = useState(null)
//     const [loading, setLoading] = useState(false)
//     const [error, setError] = useState(null)

//     const callApi = async () => {
//         setLoading(true)
//         setError(null)
//         try {
//             // Simulate an API call with a delay
//             const mockData = await new Promise(resolve => setTimeout(() => {
//                 // Mock data based on the section
//                 if (apiFn.name === 'fetchFavourites') {
//                     resolve([
//                         { id: '1', name: 'ICICI Bank FASTag', customerName: 'Prakash', vehicleNo: 'MH034589', lastLinked: 'O5 june 2025' },
//                         { id: '2', name: 'Airtel Postpaid', customerName: 'Rahul', mobileNo: '9876543210', lastLinked: '10 July 2025' }
//                     ])
//                 } else if (apiFn.name === 'fetchRecentPayments') {
//                     resolve([
//                         { id: '3', name: 'BSES Rajdhani', customerName: 'Anil', accountNo: '12345678', lastLinked: '22 May 2025' },
//                         { id: '4', name: 'JioFiber', customerName: 'Priya', accountNo: '87654321', lastLinked: '01 June 2025' }
//                     ])
//                 } else {
//                     resolve([])
//                 }
//             }, 1000))
//             setData(mockData)
//         } catch (err) {
//             setError(err)
//         } finally {
//             setLoading(false)
//         }
//     }

//     return [data, callApi, loading, error]
// }

// const mockFetchFavourites = () => { /* This function is just a placeholder to be used by the hook */ }
// const mockFetchRecentPayments = () => { /* This function is just a placeholder to be used by the hook */ }

// const staticData = [
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
// ]

// export const TransactionDetails = () => {
//     const [favourites, fetchFavourites, favouritesLoading] = useLazyApiData(mockFetchFavourites)
//     const [recentPayments, fetchRecentPayments, paymentsLoading] = useLazyApiData(mockFetchRecentPayments)
//     const [activeTab, setActiveTab] = useState('payBills')
//     const [showInactivityDialog, setShowInactivityDialog] = useState(false);
//     const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
//     const [checked, setChecked] = useState(false)
//     const routes = useRoute()
//     const handleInactivityDialogPress = () => {
//         setShowInactivityDialog(false);
//     };

//     useEffect(() => {
//         fetchFavourites()
//         fetchRecentPayments()
//     }, [])

//     const searchList = (tnxId) => {
//         console.log(tnxId)
//     }

//     const handlePress = () => {
//         setShowInactivityDialog(true)
//         console.log("enter something here.")
//     }

//     const onPrimaryButtonPress = () => {
//         setOpenConfirmDialog(true)
//     }

//     return (
//         <Container showFooter={true} overflow='auto'>
//             <>
//                 {/* <Box gap> */}
//                 <Box overflow={'auto'}>
//                     {/* <VerticleDrawerDialog
//                         show={showInactivityDialog}
//                         // message="You have been inactive for some time. Please log in again."
//                         type="POSITIVE"
//                         onPress={handleInactivityDialogPress}
//                     > */}
//                     <Box gap={15}>
//                         <Box>
//                             <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//                         </Box>
//                         <TextNew fontSize={25} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                             {"Bill Payment Successfull"}
//                         </TextNew>
//                         <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//                         <Box width={'100%'}>
//                             <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                                     {"Bank of Test- Fastag Test"}
//                                 </TextNew>
//                                 <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                                     {"Amount"}
//                                 </TextNew>
//                             </Box>
//                             <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                                 <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                                     {"TS21TR5456"}
//                                 </TextNew>
//                                 <TextNew fontSize={12} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                                     {"3000.000"}
//                                 </TextNew>
//                             </Box>
//                         </Box>
//                         <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//                         <Box marginTop={8} marginBottom={8} flexDirection={'row'} gap={40}>
//                             <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                                 {"The payment will reflect at biller's end after 2-3 working day's"}
//                             </TextNew>
//                             <Icon id={'CHECKBOX_OUTLINE'} color="AVAILABLE_GREEN" size={16} />
//                         </Box>
//                         <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//                         <Box width={'50%'}>
//                             <AepsButton
//                                 onPress={handlePress}
//                                 title={'View Details'}
//                                 disabled={false}
//                             />
//                         </Box>
//                         <Box marginTop={20} marginBottom={20} backgroundColor="#fef7e9" padding={20}>
//                             <Box paddingBottom={20}>
//                                 <TextNew fontSize={16} lineHeight={28} fontWeight={'BOLD'} color="BRAND_COLOR_GRAY_1">
//                                     {"Amount to be Paid by Customer"}
//                                 </TextNew>
//                             </Box>
//                             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} paddingBottom={15} />
//                             <Box flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
//                                 <Box>
//                                     <TextNew fontSize={22} lineHeight={28} fontWeight={'BOLD'} color="BRAND_COLOR_GRAY_1">
//                                         {"305.00"}
//                                     </TextNew>
//                                     <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                                         {"*inc. Agent fee"}
//                                     </TextNew>
//                                 </Box>
//                                 <Box>
//                                     <TextNew fontSize={16} lineHeight={28} color="BRAND_PRIMARY_ACTION">
//                                         {"view breakup"}
//                                     </TextNew>
//                                 </Box>
//                             </Box>
//                         </Box>
//                         <Box width={'100%'}>
//                             <AepsButton
//                                 onPress={onPrimaryButtonPress}
//                                 title={'Done'}
//                                 disabled={false}
//                             />
//                         </Box>
//                     </Box>

//                 </Box>
//                 <VerticleDrawerDialog
//                     show={showInactivityDialog}
//                     // message="You have been inactive for some time. Please log in again."
//                     type="POSITIVE"
//                     onPress={handleInactivityDialogPress}
//                 >
//                     <Box width={'100%'}>
//                         <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={16} />
//                         <Box gap={10}>
//                             <TextNew fontSize={24} lineHeight={28} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                                 {"300.000"}
//                             </TextNew>
//                             <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                                 {"Mobile Recharge Bill Payments"}
//                             </TextNew>
//                             <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                                 {"26 Feb 2024, 05:44 PM"}
//                             </TextNew>
//                         </Box>
//                         <Box marginBottom={20} marginTop={20} customShadowStyle='shadowPrimary' padding={15} gap={12}>
//                             <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} shadowColor={'BLACK_GRAY_SHADE'} marginBottom={20}>
//                                 <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                                     {"Transaction Details"}
//                                 </TextNew>
//                                 <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"Biller"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"Mobile Recharge Bill Payments"}
//                                 </TextNew>
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"Utr Number"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"139786275"}
//                                 </TextNew>
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"Transaction ID"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"TXN4057044156566"}
//                                 </TextNew>
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"BBPS Transaction ID"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"JIO14057000000002H386"}
//                                 </TextNew>
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"Paid by"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"UPI"}
//                                 </TextNew>
//                             </Box>
//                         </Box>
//                         <Box marginBottom={20} marginTop={20} customShadowStyle='shadowPrimary' padding={15} gap={12}>
//                             <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} shadowColor={'BLACK_GRAY_SHADE'} marginBottom={20}>
//                                 <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                                     {"Transaction Details"}
//                                 </TextNew>
//                                 <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"Biller"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"Mobile Recharge Bill Payments"}
//                                 </TextNew>
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"Utr Number"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"139786275"}
//                                 </TextNew>
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"Transaction ID"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"TXN4057044156566"}
//                                 </TextNew>
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"BBPS Transaction ID"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"JIO14057000000002H386"}
//                                 </TextNew>
//                             </Box>
//                             <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                     {"Paid by"}
//                                 </TextNew>
//                                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                     {"UPI"}
//                                 </TextNew>
//                             </Box>
//                         </Box>
//                     </Box>
//                 </VerticleDrawerDialog>
//             </>
//         </Container>
//     )
// }

// return (
//     <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
//       <Box flex={1}>
//         <Box width={'100%'} height={'100%'} justifyContent={'space-between'}>
//           {/* Header Status */}
//           <Box overflow={'auto'}>
//             <Box mb={20}>
//               <Box backgroundColor="WHITE" borderRadius={50}>
//                 <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={40} />
//               </Box>
//               <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'} textAlign="center">
//                 {'Bill Payment Successful'}
//               </TextNew>
//             </Box>
//           </Box>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//           {/* Quick Summary Row */}
//           <Box width={'100%'} mb={15}>
//             <Box flexDirection={'row'} justifyContent={'space-between'} mb={4}>
//               <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1" fontWeight="500">
//                 {product?.name || 'BBPS Biller'}
//               </TextNew>
//               <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1">
//                 {'Amount'}
//               </TextNew>
//             </Box>
//             <Box flexDirection={'row'} justifyContent={'space-between'} alignItems="center">
//               <TextNew fontSize={20} color="BLACK" fontWeight="500">
//                 {product?.attribute?.authenticatorList?.[0] || 'N/A'}
//               </TextNew>
//               <TextNew fontSize={18} color="BLACK" fontWeight={'bold'}>
//                 ₹ {amount}
//               </TextNew>
//             </Box>
//           </Box>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//           {/* Time Warning/Info */}
//           <Box
//             flexDirection={'row'}
//             alignItems="center"
//             backgroundColor="ALTO_DISABLED"
//             padding={12}
//             borderRadius={8}
//             mb={15}>
//             {/* <Icon id={'TIMER'} color="BRAND_COLOR_GRAY_1" size={16} /> */}

//             <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1" flex={1}>
//               {"Payment will reflect at biller's end after 2-3 working days"}
//             </TextNew>
//             <SpacerNew direction="horizontal" size={10} />
//             <Image source={BBPSAssuredLogo} style={{ width: 140, height: 40, resizeMode: 'contain' }} />
//           </Box>

//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//           {/* View Details Action */}
//           <TouchableOpacity onPress={handleViewDetails} style={{ paddingVertical: 10 }}>
//             <Box flexDirection="row" alignItems="center" justifyContent="space-between">
//               <TextNew fontSize={16} color="BRAND_PRIMARY_ACTION" fontWeight="500">
//                 {'View Details'}
//               </TextNew>
//               <Icon id="ARROW_RIGHT" color="BRAND_PRIMARY_ACTION" size={14} />
//             </Box>
//           </TouchableOpacity>

//           {/* Amount Card Section */}
//           <Box mt={20} backgroundColor="WHITE" padding={20} borderRadius={16} customShadowStyle="shadowPrimary">
//             <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1" fontWeight="bold">
//               {'Amount Paid by Customer'}
//             </TextNew>
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//             <Box flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
//               <Box>
//                 <TextNew fontSize={22} fontWeight={'BOLD'} color="BLACK">
//                   ₹ {amount}
//                 </TextNew>
//                 <TextNew fontSize={11} color="BRAND_COLOR_GRAY_2">
//                   {'*Inclusive of all taxes & fees'}
//                 </TextNew>
//               </Box>
//               <TouchableOpacity onPress={() => setShowDetailsDrawer(true)}>
//                 <Box flexDirection="row" alignItems="center">
//                   <TextNew fontSize={14} color="BRAND_PRIMARY_ACTION" fontWeight="500">
//                     {'View Breakup'}
//                   </TextNew>
//                   <SpacerNew direction="horizontal" size={4} />
//                   <Icon id="ARROW_DOWN" color="BRAND_PRIMARY_ACTION" size={12} />
//                 </Box>
//               </TouchableOpacity>
//             </Box>
//           </Box>
//         </Box>

//         {/* Footer Actions */}
//         <Box width={'100%'} mt={20}>
//           <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
//           <Box flexDirection="row" align="center" justify="center" mt={15}>
//             <TextNew fontSize={11} color="BRAND_COLOR_GRAY_1">
//               Powered by
//             </TextNew>
//             <SpacerNew direction="horizontal" size={8} />
//             <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
//           </Box>
//         </Box>
//       </Box>

//       {/* Breakup Drawer */}
//       <VerticleDrawerDialog
//         show={showDetailsDrawer}
//         type="POSITIVE"
//         message="VerticleDrawerDialog message"
//         onPress={() => setShowDetailsDrawer(false)}>
//         <Box width={'100%'} padding={5}>
//           <Box alignItems="center" mb={20}>
//             <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={30} />
//             <SpacerNew size={8} />
//             <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//               ₹ {amount}
//             </TextNew>
//             <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
//               {product?.name}
//             </TextNew>
//           </Box>

//           <Box backgroundColor="ALTO_DISABLED" padding={15} borderRadius={12} gap={12}>
//             <DrawerRow label="Biller" value={product?.name} />
//             <DrawerRow label="Agent Commission" value="₹ 0.00" />
//             <DrawerRow label="Net Amount" value={`₹ ${amount}`} isBold />
//             <Box height={1} backgroundColor="WHITE" marginVertical={4} />
//             <DrawerRow label="Transaction ID" value={orderId} />
//             <DrawerRow label="BBPS Ref No." value={paymentId} />
//             <DrawerRow label="Payment Time" value={formattedPaymentDate} />
//           </Box>

//           <Box width={'100%'} mt={20}>
//             <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
//             <Box flexDirection="row" align="center" justify="center" mt={15}>
//               <TextNew fontSize={11} color="BRAND_COLOR_GRAY_1">
//                 Powered by
//               </TextNew>
//               <SpacerNew direction="horizontal" size={8} />
//               <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
//             </Box>
//           </Box>
//         </Box>
//       </VerticleDrawerDialog>
//     </Container>
//   )
